import { Link } from 'react-router-dom';
import './ChatModeSelector.css';

export const CHAT_MODES = [
  {
    id: 'simple',
    label: 'Simple chat',
    hint: 'Plain text conversation',
    requiresAdvanced: false,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <path
          d="M4 5H20V16H8L4 20V5Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    id: 'docs',
    label: 'Read & write',
    hint: 'Attach a document for feedback',
    requiresAdvanced: true,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <path
          d="M14 3H7C5.9 3 5 3.9 5 5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V8L14 3Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path d="M14 3V8H19" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        <path d="M8.5 13H15.5M8.5 16.5H13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    id: 'image',
    label: 'Image generation',
    hint: 'Create images from a prompt',
    requiresAdvanced: true,
    icon: (
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
        <circle cx="8.5" cy="9.5" r="1.5" stroke="currentColor" strokeWidth="2" />
        <path d="M21 15L15.5 10L5 20" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
      </svg>
    ),
  },
];

export default function ChatModeSelector({ mode, onChange, isAdvanced, canUpgrade = true }) {
  return (
    <div className="chat-mode-selector">
      {CHAT_MODES.map((m) => {
        const locked = m.requiresAdvanced && !isAdvanced;
        return (
          <div key={m.id} className="chat-mode-item">
            <button
              type="button"
              className={`chat-mode-pill ${mode === m.id ? 'chat-mode-pill--active' : ''} ${
                locked ? 'chat-mode-pill--locked' : ''
              }`}
              onClick={() => !locked && onChange(m.id)}
              disabled={locked}
              title={locked ? undefined : m.hint}
            >
              {m.icon}
              {m.label}
            </button>
            {locked && (
              <div className="chat-mode-tooltip">
                {canUpgrade ? (
                  <>
                    You need an Advanced-tier account to use this. <Link to="/account">Upgrade now</Link>
                  </>
                ) : (
                  'You need an Advanced-tier account to use this. Contact your organization administrator to upgrade.'
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
